import { render } from "./Step_four.vue?vue&type=template&id=ac730692"
import script from "./Step_four.vue?vue&type=script&lang=js"
export * from "./Step_four.vue?vue&type=script&lang=js"

import "./Step_four.vue?vue&type=style&index=0&id=ac730692&lang=less"
script.render = render

export default script